export const getters = {
    loggedIn: state => state.loggedIn,
    userInfo: state => state.userInfo,
    userId: state => state.userInfo && state.userInfo.userId,
    schoolInfo: state => state.schoolInfo,
    schoolName: state => state.schoolInfo && state.schoolInfo.schoolName,
    schoolCurrency: state => state.schoolInfo && state.schoolInfo.currency,
    schoolCountry: state => state.schoolInfo && state.schoolInfo.country,
    dateFormat: state => state.schoolInfo && state.schoolInfo.dateFormat || 'mm/dd/yyyy',
    dateFormatYearShort: state => state.schoolInfo && state.schoolInfo.dateFormat &&
        state.schoolInfo.dateFormat.slice(0, state.schoolInfo.dateFormat.length - 2) || 'mm/dd/yy'
};


// WEBPACK FOOTER //
// ./src/store/modules/authentication/getters.js